module.exports = __webpack_public_path__ + "img/logo_pracavbratislave.1a6e382.svg";